import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { Header } from 'formlabs-web-components/Type';
import { Spinner } from 'formlabs-web-components/Navigation';
import { analytics } from '../../utils';
import identifyIntegrations from './identifyIntegrations';

import './NewsLetterSignUp.module.css';

class NewsletterSignUp extends PureComponent {
  state = {
    submitting: false,
    submitted: false,
    error: false
  };
  onFormSubmit = async e => {
    this.setState({ submitting: true, error: false });
    e.preventDefault();
    const csrftoken = Cookies.get('csrftoken');
    const form = e.target;
    let form_data = new FormData(form);

    analytics.identify(
      form_data.get('tfa_1'),
      {
        email: form_data.get('tfa_1')
      },
      identifyIntegrations
    );
    analytics.track(
      'Newsletter Subscribed',
      {
        category: 'Segment',
        email: form_data.get('tfa_1')
      },
      {
        integrations: {
          Marketo: false,
          'Marketo V2': false
        }
      }
    );

    const response = await fetch(form.action, {
      method: 'POST',
      body: form_data,
      headers: {
        'X-CSRFToken': csrftoken
      }
    });
    const json = await response.json();
    if (json !== 400 && json < 500) {
      this.setState({ submitted: true });
    } else {
      this.setState({ submitted: false, submitting: false, error: true });
    }
  };
  render() {
    const { t, layoutType } = this.props;
    const { submitting, submitted, error } = this.state;
    const isSidebar = layoutType === 'sidebar';

    return (
      <div styleName={`newsletter-${layoutType}`}>
        {isSidebar && (
          <Header level={6} displayAs={6} weight={400}>
            {t('Sign up for our newsletter')}
          </Header>
        )}
        <form
          method="post"
          action="/form_proxy/"
          className="hintsBelow labelsAbove"
          onSubmit={this.onFormSubmit}
        >
          {!submitted && (
            <Fragment>
              <input
                type="email"
                name="tfa_1"
                placeholder={t('Enter email')}
                title={t('Email')}
                aria-label={t('Email')}
                className="validate-email required"
                required
              />

              {submitting && !isSidebar && (
                <span styleName="submitting">
                  <Spinner size={3} color="#fff" />
                </span>
              )}

              {submitting && isSidebar && (
                <span styleName="submitting">
                  <Spinner size={3} color="#000" />
                </span>
              )}
              {!submitting && !isSidebar && (
                <button type="submit">
                  <span styleName="visually-hidden">{t('Sign Up')}</span>
                  <i className="fl-arrow-right" aria-hidden="true" />
                </button>
              )}

              {!submitting && isSidebar && (
                <button color="dark" type="submit">
                  <span>{t('Sign Up')}</span>
                </button>
              )}

              {error && (
                <p>{t('There was an error signing up, please try again.')}</p>
              )}
            </Fragment>
          )}
          {submitted && (
            <div styleName="submitted">
              <span>{t('Thanks for your submission.')}</span>
              <i className="fl-baseline-check_circle_outline-24px" />
            </div>
          )}
          <div>
            <input
              type="hidden"
              name="tfa_3"
              value=""
              placeholder=""
              title="Referral URL"
              className=""
            />

            <input
              type="hidden"
              name="tfa_5"
              value=""
              placeholder=""
              title="Language Preference"
              className=""
            />

            <input
              type="hidden"
              name="tfa_8"
              value=""
              placeholder=""
              title="_tfa_mkt_trk"
              className=""
            />

            <input
              type="hidden"
              name="tfa_9"
              value=""
              placeholder=""
              title="Acquisition Source - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_10"
              value=""
              placeholder=""
              title="Acquisition Source - Last"
              className=""
            />

            <input
              type="hidden"
              name="tfa_11"
              value=""
              placeholder=""
              title="gclid"
              className=""
            />

            <input
              type="hidden"
              name="tfa_12"
              value=""
              placeholder=""
              title="utm_campaign - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_13"
              value=""
              placeholder=""
              title="utm_campaign - Latest"
              className=""
            />

            <input
              type="hidden"
              name="tfa_14"
              value=""
              placeholder=""
              title="utm_pt - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_15"
              value=""
              placeholder=""
              title="utm_pt - Latest"
              className=""
            />

            <input
              type="hidden"
              name="tfa_16"
              value=""
              placeholder=""
              title="utm_content - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_17"
              value=""
              placeholder=""
              title="utm_content - Latest"
              className=""
            />

            <input
              type="hidden"
              name="tfa_18"
              value=""
              placeholder=""
              title="utm_term - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_19"
              value=""
              placeholder=""
              title="utm_term - Latest"
              className=""
            />

            <input
              type="hidden"
              name="tfa_20"
              value=""
              placeholder=""
              title="utm_medium - First"
              className=""
            />

            <input
              type="hidden"
              name="tfa_21"
              value=""
              placeholder=""
              title="utm_medium - Latest"
              className=""
            />
            <input type="hidden" value="428443" name="tfa_dbFormId" />
            <input type="hidden" value="" name="tfa_dbResponseId" />
            <input
              type="hidden"
              value="82752995589e4bb1cf20b2ef0384d903"
              name="tfa_dbControl"
            />
            <input type="hidden" value="15" name="tfa_dbVersionId" />
            <input type="hidden" value="" name="tfa_switchedoff" />
          </div>
        </form>
      </div>
    );
  }
}

export default withTranslation()(NewsletterSignUp);
